import Link from 'next/link';
import React, { memo } from 'react';
import Image from 'next/image';

const isExternal = (url: string) => url.startsWith('http://') || url.startsWith('https://');

const Card = memo(function Card({
                                 title,
                                 description,
                                 href,
                                 buttonText,
                                 imageUrl,
                               }: {
    title: string;
    description: string;
    href?: string;
    buttonText?: string;
    imageUrl?: string;
}) {
    const inner = (
        <article
            className="relative glass-card p-5 flex flex-col justify-center glass-hover glass-transition h-full overflow-hidden">
            {imageUrl && (isExternal(imageUrl) ? (
                // eslint-disable-next-line @next/next/no-img-element -- external image hosts are not listed in next.config remotePatterns
                <img
                    src={imageUrl}
                    alt={title}
                    loading="lazy"
                    className="absolute inset-0 z-0 w-full h-full object-cover opacity-40"
                />
            ) : (
                <Image
                    src={imageUrl}
                    alt={title}
                    fill
                    sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 33vw"
                    style={{ objectFit: 'cover' }}
                    className="absolute inset-0 z-0 opacity-40"
                />
            ))}
            <div className="relative z-10 flex flex-col flex-1">
                <p className="text-xl font-semibold text-white mb-4 mt-10">{title}</p>
                <div className="flex-1 flex items-center justify-center">
                    <p className="text-sm text-white/70 leading-normal overflow-hidden text-ellipsis"
                       style={{
                           display: '-webkit-box',
                           WebkitLineClamp: 3,
                       }}
                    >
                        {description}
                    </p>
                </div>
            </div>
            {buttonText &&
                <div
                    className="relative z-10 mt-4 text-center bg-white/10 py-2 px-4 text-sm font-bold text-white glass-transition hover:bg-white/20">
                    {buttonText}
                </div>
            }
        </article>
    );

    return href ? (
        <Link href={href} className="block h-[400px]">
            {inner}
        </Link>
    ) : (
        <div className="h-[400px]">
            {inner}
        </div>
    );
});

export default Card;
